// 产品图片
import u21 from '../assets/images/home/21.png'
//首页图片
// import homePng1 from '../assets/images/home/home1.png'
// import homePng2 from '../assets/images/home/home2.png'
// import homePng3 from '../assets/images/home/home3.png'
// import homePng4 from '../assets/images/home/home4.png'
// import homePng5 from '../assets/images/home/home5.png'
//案例图片
import casePng1 from '../assets/images/case/case1.PNG'
import casePng2 from '../assets/images/case/case2.PNG'
import casePng3 from '../assets/images/case/case3.PNG'
import casePng4 from '../assets/images/case/case4.JPG'
import casePng5 from '../assets/images/case/case5.PNG'
import casePng6 from '../assets/images/case/case6.PNG'
import casePng7 from '../assets/images/case/case7.PNG'
import casePng8 from '../assets/images/case/case8.PNG'


import casePng56 from '../assets/images/case4/天津舞台租赁.jpg'
import casePng57 from '../assets/images/case4/英国户外项目案例.png'
import casePng58 from '../assets/images/case4/南通户外租赁项目.png'

import casePng10 from '../assets/images/case1/上海室内小间距.jpg'
import casePng11 from '../assets/images/case1/会议室室内项目.png'
import casePng12 from '../assets/images/case1/会议室小间距.png'
import casePng13 from '../assets/images/case1/会议室案例.png'
import casePng15 from '../assets/images/case1/会议室项目.jpg'
import casePng16 from '../assets/images/case1/医院会议室项目.jpg'
import casePng18 from '../assets/images/case1/博物馆小间距室内屏.png'
import casePng19 from '../assets/images/case1/商场室内项目.png'
import casePng20 from '../assets/images/case1/商场小间距.png'
import casePng21 from '../assets/images/case1/商场户外大屏.png'
import casePng22 from '../assets/images/case1/商场服装店.png'


import casePng30 from '../assets/images/case3/LED晶膜屏.jpg'
import casePng31 from '../assets/images/case3/会议展示魔方屏.png'
import casePng32 from '../assets/images/case3/服装店LED魔方屏.png'
import casePng33 from '../assets/images/case3/超市.jpg'
import casePng34 from '../assets/images/case3/超市室内LED魔方屏.png'
import casePng35 from '../assets/images/case3/餐饮店LED魔方屏.jpg'
import casePng36 from '../assets/images/case3/魔方办公室摆台.jpg'
import casePng37 from '../assets/images/case3/餐饮案例.jpg'
import casePng38 from '../assets/images/case3/餐馆案例.jpg'
import casePng39 from '../assets/images/case3/晶膜屏案例.JPG'

import casePng40 from '../assets/images/case2/上海商场项目.jpg'
import casePng41 from '../assets/images/case2/上海铁塔项目.jpg'
import casePng42 from '../assets/images/case2/上海闵行项目.jpg'
import casePng43 from '../assets/images/case2/保定博物馆项目.jpg'
import casePng44 from '../assets/images/case2/北京珠宝店项目.png'
import casePng45 from '../assets/images/case2/商场透明屏案例.jpg'
import casePng46 from '../assets/images/case2/商演项目.jpg'
import casePng47 from '../assets/images/case2/圆形透明屏案例.png'
import casePng48 from '../assets/images/case2/地铁站项目.jpg'
import casePng49 from '../assets/images/case2/宁波户外项目.jpg'

import { getLangName as t } from './index'

export const caseList4 = [{
  title: t('ShanghaiShoppingMallProject'),
  img: casePng40,
}, {
  title: t('ShanghaiTowerProject'),
  img: casePng41,
}, {
  title: t('ShanghaiMinhangProject'),
  img: casePng42,
}, {
  title: t('BaodingMuseumProject'),
  img: casePng43,
}, {
  title: t('BeijingJewelryStoreProject'),
  img: casePng44,
}, {
  title: t('ShoppingMallTransparentScreenCase'),
  img: casePng45,
}, {
  title: t('CommercialPerformanceProject'),
  img: casePng46,
}, {
  title: t('RoundTransparentScreenCase'),
  img: casePng47,
}, {
  title: t('SubwayStationProject'),
  img: casePng48,
}, {
  title: t('NingboOutdoorProject'),
  img: casePng49,
}]

export const caseList3 = [{
  title: t('LEDCrystalFilmScreen'),
  img: casePng30,
}, {
  title: t('ConferenceDisplayMagicCubeScreen'),
  img: casePng31,
}, {
  title: t('ClothingStoreLEDMagicCubeScreen'),
  img: casePng32,
}, {
  title: t('Supermarket'),
  img: casePng33,
}, {
  title: t('SupermarketIndoorLEDMagicCubeScreen'),
  img: casePng34,
}, {
  title: t('RestaurantLEDMagicCubeScreen'),
  img: casePng35,
}, {
  title: t('MagicCubeOfficeDisplay'),
  img: casePng36,
}, {
  title: t('RestaurantCase'),
  img: casePng37,
}, {
  title: t('DiningCase'),
  img: casePng38,
}, {
  title: t('CrystalFilmScreenCase'),
  img: casePng39,
}]

export const caseList2 = [{
  title: t('ShanghaiIndoorSmallPitch'),
  img: casePng10,
}, {
  title: t('MeetingRoomIndoorProject'),
  img: casePng11,
}, {
  title: t('MeetingRoomSmallPitch'),
  img: casePng12,
}, {
  title: t('MeetingRoomCase'),
  img: casePng13,
}, {
  title: t('MeetingRoomProject'),
  img: casePng15,
}, {
  title: t('HospitalMeetingRoomProject'),
  img: casePng16,
}, {
  title: t('MuseumSmallPitchIndoorScreen'),
  img: casePng18,
}, {
  title: t('MuseumSmallPitchIndoorScreen'),
  img: casePng18,
}, {
  title: t('ShoppingMallIndoorProject'),
  img: casePng19,
}, {
  title: t('ShoppingMallSmallPitch'),
  img: casePng20,
}, {
  title: t('ShoppingMallOutdoorLargeScreen'),
  img: casePng21,
}, {
  title: t('ShoppingMallClothingStore'),
  img: casePng22,
}]

export const caseList5 = [{
  title: t('TianjinStageRental'),
  img: casePng56,
}, {
  title: t('UKOutdoorProjectCase'),
  img: casePng57,
}, {
  title: t('NantongOutdoorRentalProject'),
  img: casePng58,
}]

export const caseList1 = [{
  title: t('P186FiveUnitsParallel'),
  img: casePng1,
}, {
  title: t('P25Indoor'),
  img: casePng2,
}, {
  title: t('CakeShopCase'),
  img: casePng3
}, {
  title: t('ClothingStoreCase'),
  img: casePng4
}, {
  title: t('DigitalSignageCase'),
  img: casePng5
}, {
  title: t('IndoorDigitalSignage2'),
  img: casePng6
}, {
  title: t('IndoorDigitalSignage3'),
  img: casePng7
}, {
  title: t('IndoorDigitalSignage'),
  img: casePng8
}]

const productList = [{
  key: '1',
  title: t('product1'),
  img: u21,
}]

export default productList